import { Subject } from 'rxjs'
import Vue from 'vue'

export default class BaseDialog extends Vue {
  /**
   * モーダル表示状態
   */
  active = false

  /**
   * ダイアログが閉じた際の通知
   */
  afterClosed = new Subject()
  afterClosed$ = this.afterClosed.asObservable()

  /**
   * ダイアログを表示
   */
  show() {
    this.active = true
  }
  /**
   * ダイアログを閉じる
   * @param {*} arg ダイアログを開いたコンポーネントへ通知する値
   */
  hide(arg = undefined) {
    this.active = false
    this.afterClosed.next(arg)
  }
}
